import { TabPanel, TabView } from "primereact/tabview";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { Icon } from "../../../shared/icons/icon";
import { SpecialLabelCases } from "../../../shared/models/utilities";
import { SERVICES } from "../../../core/services/services";
import { HELPER } from "../../../shared/helper/helper";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { Optional } from "../optional/optional";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { UserTypes } from "../../constants";
import { Toast } from "primereact/toast";

export function MandateCancellationRequestDetails(props) {
  const toast = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);
  const [detailsContent, setDetailsContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mandateReference, setMandateReference] = useState();

  const getMandateByReference = useCallback(
    (reference) => {
      setLoading(true);
      setCurrentIndex(0);
      const frontOfficeUrl = FRONTOFFICE_API.DEBIT_MANDATES;
      const backOfficeUrl = BACKOFFICE_API.DEBIT_MANDATES;
      const url =
        props.userType === UserTypes.Frontoffice
          ? frontOfficeUrl
          : backOfficeUrl;
      SERVICES.MAKE_GET_REQUEST(
        `${url}/${reference ? reference : mandateReference}`
      )
        .then((data) => {
          const result = data.result;
          setMandateReference(result?.reference);
          setDetailsContent(HELPER.GET_DETAILS_ARRAY(result));
          setError(null);
          setLoading(false);
        })
        .catch((error) => {
          setError(HELPER.PROCESS_ERROR(error));
          setLoading(false);
        });
    },
    [mandateReference, props.userType]
  );

  useEffect(() => {
    const reference = props?.mandate
      ? props?.mandate?.reference
      : props.mandateReference;

    getMandateByReference(reference);
  }, [getMandateByReference, props.mandateReference, props.mandate]);

  function viewMandate() {
    console.log("view-mandate-page");
  }

  const transformView = (itemCase, value, type) => {
    let result = value;
    if (itemCase) {
      SpecialLabelCases.forEach((e) => {
        if (e.case === itemCase) {
          result = e.action(value);
        }
      });
    }
    return result;
  };

  const detailsView = () => {
    return detailsContent.map((details, index) => (
      <div key={details.label || index.toString()} className="p-grid dcir-row">
        <div className="p-col-6">
          <p className="details-label">{details.label}:</p>
        </div>
        <div className="p-col-6">
          {details.label === "mandateReference" ? (
            <button className="bare-button" onClick={viewMandate}>
              {details.value}
            </button>
          ) : (
            <p className="details-value">
              {transformView(details.itemCase, details.value, details.type)}
            </p>
          )}
        </div>
      </div>
    ));
  };

  const errorView = () => {
    return (
      <div>
        <div className="empty-container">
          <div className="p-text-center">
            <Icon icon="error-message-icon" />
          </div>
          <div>
            <p className="empty-text">{error}</p>
          </div>
          <div className="p-mt-3">
            <div style={{ maxWidth: "200px", margin: "0 auto" }}>
              <button
                className="primary-button"
                onClick={getMandateByReference}
              >
                Reload
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const mandateTabView = () => {
    return (
      <div
        style={{ backgroundColor: "#ffffff", paddingTop: "1em" }}
        className="p-shadow-1 p-pb-5"
      >
        <div className="p-text-left p-ml-3 p-mt-2 p-pb-3">
          <span onClick={() => props?.goBack()} className="add-cursor">
            <span>
              <Icon icon="go-back-icon" />
            </span>
          </span>
        </div>
        <TabView>
          <TabPanel header="Mandate Details">
            <div className="p-text-left">
              <Optional show={!loading}>
                <div className="p-grid p-mt-2">
                  <div className="p-col-10" />
                  <div className="p-col-2">
                    <button
                      className="primary-button"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Conversions and Status Log
                    </button>
                  </div>
                </div>
              </Optional>
              <Optional show={!loading && !error}>
                <div className="centralize">{detailsView()}</div>
              </Optional>
              <Optional show={loading}>
                <div style={{ margin: "10rem 0" }} className="p-text-center">
                  <CustomLoader loadingText="Loading..." />
                </div>
              </Optional>
              <Optional show={error && !loading}>{errorView()}</Optional>
            </div>
          </TabPanel>
        </TabView>
      </div>
    );
  };

  const mandateDetailsView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return mandateTabView();
      case 1:
        return errorView();
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      {mandateDetailsView()}
    </div>
  );
}
